"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantInfoQueryToJSON = exports.ApplicantInfoQueryFromJSONTyped = exports.ApplicantInfoQueryFromJSON = void 0;
const _1 = require("./");
function ApplicantInfoQueryFromJSON(json) {
    return ApplicantInfoQueryFromJSONTyped(json, false);
}
exports.ApplicantInfoQueryFromJSON = ApplicantInfoQueryFromJSON;
function ApplicantInfoQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enrollmentId': json['enrollmentId'],
        'name': _1.NameObjectFromJSON(json['name']),
        'determinationStatus': json['determinationStatus'],
        'contact': _1.PreContactStepFromJSON(json['contact']),
        'clearPromotionsOptIn': json['clearPromotionsOptIn'],
    };
}
exports.ApplicantInfoQueryFromJSONTyped = ApplicantInfoQueryFromJSONTyped;
function ApplicantInfoQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enrollmentId': value.enrollmentId,
        'name': _1.NameObjectToJSON(value.name),
        'determinationStatus': value.determinationStatus,
        'contact': _1.PreContactStepToJSON(value.contact),
        'clearPromotionsOptIn': value.clearPromotionsOptIn,
    };
}
exports.ApplicantInfoQueryToJSON = ApplicantInfoQueryToJSON;
//# sourceMappingURL=ApplicantInfoQuery.js.map